export interface Movie {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  description: string;
  imageUrl: string;
  isHot: boolean;
  isNew: boolean;
  region: string;
  fullDescription: string;
  releaseDate: string;
  language: string;
}

export const categories: { name: string; slug: string; icon: string }[] = [
  { name: '动作片', slug: 'action', icon: 'ri-sword-line' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line' },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '动画片', slug: 'animation', icon: 'ri-movie-line' },
  { name: '悬疑片', slug: 'suspense', icon: 'ri-search-eye-line' },
  { name: '战争片', slug: 'war', icon: 'ri-shield-flash-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: '科幻片',
    categorySlug: 'scifi',
    year: 2025,
    rating: 8.6,
    duration: '148分钟',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出，展开争分夺秒的生死之战。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20featuring%20astronauts%20on%20a%20frozen%20planet%20with%20massive%20space%20engines%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20atmosphere%20with%20warm%20orange%20highlights%2C%20epic%20scale%2C%20movie%20poster%20style%20with%20Chinese%20text%20space&width=600&height=900&seq=movie-scifi-1&orientation=portrait',
    isHot: true,
    isNew: true,
    region: '中国大陆',
    fullDescription: '在不远的未来，太阳急速衰老膨胀，地球面临被吞没的危机。为拯救地球，人类在地球表面建造了上万座行星发动机，驱动地球逃离太阳系，踏上长达2500年的宇宙流浪之旅。在这场漫长而危险的旅程中，人类面临着前所未有的挑战——极寒环境、资源匮乏、以及人类内部的纷争。年轻一代的宇航员和工程师们挺身而出，他们不仅要应对外部的宇宙威胁，还要在绝境中守护人类的希望与文明的火种。',
    releaseDate: '2025-02-10',
    language: '汉语普通话',
  },
  {
    id: 'movie-2',
    title: '战狼3',
    category: '动作片',
    categorySlug: 'action',
    year: 2025,
    rating: 8.2,
    duration: '135分钟',
    director: '吴京',
    cast: ['吴京', '余男', '弗兰克·格里罗'],
    description: '冷锋再度出征，面对国际恐怖组织的威胁，孤身深入敌后，展开了一场惊心动魄的营救行动，用热血捍卫国家尊严与人民安全。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20soldier%20in%20combat%20gear%20holding%20weapon%2C%20explosion%20background%2C%20intense%20dramatic%20lighting%2C%20cinematic%20style%2C%20dark%20moody%20atmosphere%20with%20fire%20and%20smoke%2C%20movie%20poster%20aesthetic&width=600&height=900&seq=movie-action-1&orientation=portrait',
    isHot: true,
    isNew: true,
    region: '中国大陆',
    fullDescription: '前特种部队战士冷锋意外卷入一场国际恐怖组织的阴谋之中。为了营救被困海外的中国公民，他孤身前往战火纷飞的异国他乡，在极端危险的环境中与恐怖分子展开殊死搏斗。面对重重包围和背叛，冷锋凭借过人的军事素养和坚定的信念，一步步瓦解敌人的计划，用生命守护每一个同胞的安全。这不仅是一场个人的战斗，更是中国军人对国家和人民誓言的践行。',
    releaseDate: '2025-03-15',
    language: '汉语普通话',
  },
  {
    id: 'movie-3',
    title: '热辣滚烫2',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2025,
    rating: 7.9,
    duration: '128分钟',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    description: '乐莹在拳击世界找到自我后，开启全新人生旅程。当事业与爱情面临新挑战时，她用幽默与坚韧继续书写属于自己的精彩故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20comedy%20movie%20poster%20with%20female%20lead%20smiling%20confidently%2C%20warm%20golden%20lighting%2C%20boxing%20gloves%20motif%2C%20uplifting%20atmosphere%2C%20bright%20cinematic%20colors%2C%20heartwarming%20movie%20poster%20style&width=600&height=900&seq=movie-comedy-1&orientation=portrait',
    isHot: true,
    isNew: false,
    region: '中国大陆',
    fullDescription: '在前作中通过拳击找到人生方向的乐莹，如今已经成为一名小有名气的健身教练。然而生活总是充满意外，当她的拳击馆面临拆迁危机，同时一段意外的感情悄然降临，乐莹需要再次拿出那股不服输的劲头。这一次，她不仅要保护自己珍视的事业，还要学会在爱情中保持独立的自我。笑中有泪，热辣依旧滚烫。',
    releaseDate: '2025-01-28',
    language: '汉语普通话',
  },
  {
    id: 'movie-4',
    title: '哪吒之魔童闹海',
    category: '动画片',
    categorySlug: 'animation',
    year: 2025,
    rating: 8.9,
    duration: '142分钟',
    director: '饺子',
    cast: ['吕艳婷', '陈浩', '囧森瑟夫'],
    description: '天劫之后，哪吒与敖丙灵魂虽保但肉身濒危。太乙真人欲以七色宝莲重塑其身，然而重重险阻之下，哪吒将何去何从？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20featuring%20a%20mythological%20boy%20warrior%20with%20flaming%20hair%20and%20red%20sash%2C%20epic%20fantasy%20style%2C%20vibrant%20colors%20with%20fire%20and%20thunder%2C%20traditional%20Chinese%20art%20influence%2C%20cinematic%20quality&width=600&height=900&seq=movie-animation-1&orientation=portrait',
    isHot: true,
    isNew: true,
    region: '中国大陆',
    fullDescription: '经历天劫之后，哪吒和敖丙的灵魂虽然得以保存，但他们的肉身却濒临毁灭。太乙真人决定使用传说中的七色宝莲为他们重塑肉身，然而这一过程充满了未知的挑战与危险。与此同时，一股来自深海的神秘力量正在暗中涌动，龙族的复仇计划也逐渐浮出水面。哪吒必须在灵魂与肉身的重塑过程中，面对自己内心最深的恐惧，才能真正成长为一个顶天立地的英雄。',
    releaseDate: '2025-07-20',
    language: '汉语普通话',
  },
  {
    id: 'movie-5',
    title: '封神第二部：战火西岐',
    category: '动作片',
    categorySlug: 'action',
    year: 2025,
    rating: 8.4,
    duration: '145分钟',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    description: '殷商大军兵临西岐，姜子牙率众将士迎战。姬发在战火中逐渐觉醒领袖之力，一场关乎天下命运的史诗之战拉开帷幕。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20war%20movie%20poster%20with%20ancient%20warriors%20in%20armor%2C%20massive%20battle%20scene%2C%20dramatic%20sky%20with%20fire%2C%20mythological%20elements%2C%20grand%20cinematic%20scale%2C%20dark%20and%20golden%20color%20palette&width=600&height=900&seq=movie-action-2&orientation=portrait',
    isHot: true,
    isNew: true,
    region: '中国大陆',
    fullDescription: '殷商太师闻仲率大军征伐西岐，兵临城下。姜子牙与姬发率领西岐军民奋起抵抗。在这场关乎天下苍生的大战中，各路神仙妖魔纷纷登场，天地为之变色。姬发在血与火的洗礼中，逐渐领悟到为君之道的真谛，从一个懵懂少年成长为真正的领袖。而隐藏在战争背后的更大阴谋，也在慢慢浮出水面。',
    releaseDate: '2025-05-01',
    language: '汉语普通话',
  },
  {
    id: 'movie-6',
    title: '孤注一掷2',
    category: '悬疑片',
    categorySlug: 'suspense',
    year: 2025,
    rating: 8.1,
    duration: '130分钟',
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君'],
    description: '网络诈骗集团死灰复燃，手段更加隐蔽。警方与国际反诈组织联手，深入虎穴，展开一场高科技与人性博弈的跨国追捕行动。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20with%20digital%20code%20and%20shadowy%20figures%2C%20dark%20cyberpunk%20aesthetic%2C%20mysterious%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20tension%2C%20modern%20tech%20noir%20style&width=600&height=900&seq=movie-suspense-1&orientation=portrait',
    isHot: false,
    isNew: true,
    region: '中国大陆',
    fullDescription: '在前作揭露境外网络诈骗内幕之后，诈骗集团并未就此消失，反而以更加隐蔽和高科技的手段卷土重来。这一次，他们将魔爪伸向了更多的无辜民众。中国警方联合国际反诈组织，组建了一支精英小队，深入诈骗集团的核心腹地。在这场猫鼠游戏中，每一个选择都可能致命，每一个信任都可能成为陷阱。正义与邪恶的较量，在数字世界的暗影中悄然展开。',
    releaseDate: '2025-04-18',
    language: '汉语普通话',
  },
  {
    id: 'movie-7',
    title: '长津湖之水门桥',
    category: '战争片',
    categorySlug: 'war',
    year: 2023,
    rating: 8.3,
    duration: '149分钟',
    director: '陈凯歌 / 徐克 / 林超贤',
    cast: ['吴京', '易烊千玺', '朱亚文', '李晨'],
    description: '抗美援朝战场上，七连战士们在极端严寒中，为了炸毁水门桥阻断敌军退路，展开了一场英勇壮烈的战斗。',
    imageUrl: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20with%20soldiers%20in%20snow%20battlefield%2C%20winter%20combat%20scene%2C%20dramatic%20cold%20atmosphere%2C%20heroic%20composition%2C%20cinematic%20war%20photography%2C%20muted%20cool%20tones&width=600&height=900&seq=movie-war-1&orientation=portrait',
    isHot: false,
    isNew: false,
    region: '中国大陆',
    fullDescription: '1950年，抗美援朝战争第二次战役中，中国人民志愿军第九兵团在长津湖地区与美军展开殊死搏斗。七连战士们在零下四十度的极端严寒中，奉命炸毁美军撤退必经的水门桥。面对装备精良的敌人和恶劣的自然环境，战士们以血肉之躯筑起了一道不可逾越的防线。他们的英勇与牺牲，成为了战争史上的不朽传奇。',
    releaseDate: '2023-01-22',
    language: '汉语普通话',
  },
  {
    id: 'movie-8',
    title: '消失的她',
    category: '悬疑片',
    categorySlug: 'suspense',
    year: 2023,
    rating: 7.8,
    duration: '122分钟',
    director: '崔睿 / 刘翔',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    description: '何非的妻子在海外度假时离奇失踪，当他四处寻找时，一个神秘女人自称是他的妻子，而所有人都相信她。真相究竟是什么？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20with%20a%20woman%20silhouette%20disappearing%2C%20tropical%20island%20background%2C%20dark%20moody%20tones%2C%20psychological%20suspense%2C%20cinematic%20noir%20style%2C%20enigmatic%20atmosphere&width=600&height=900&seq=movie-suspense-2&orientation=portrait',
    isHot: false,
    isNew: false,
    region: '中国大陆',
    fullDescription: '何非和妻子李木子前往东南亚某海岛度假，庆祝结婚周年。然而在一个普通的夜晚，妻子离奇失踪。何非报案后苦苦寻找，第二天早上，一个陌生女人躺在他身边，声称自己就是他的妻子。酒店员工、监控录像，甚至护照信息都证明这个女人就是李木子。何非陷入了一个巨大的谜团之中——究竟是所有人都在骗他，还是他自己出了问题？',
    releaseDate: '2023-06-22',
    language: '汉语普通话',
  },
  {
    id: 'movie-9',
    title: '人生大事2',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2025,
    rating: 8.0,
    duration: '125分钟',
    director: '刘江江',
    cast: ['朱一龙', '杨恩又', '王戈'],
    description: '殡葬师莫三妹再次遇到改变人生的契机。当一位特殊的客户带来了不可思议的委托，他开始重新思考生命与死亡的意义。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Heartwarming%20comedy-drama%20movie%20poster%20with%20a%20man%20and%20little%20girl%2C%20warm%20sunset%20lighting%2C%20emotional%20connection%2C%20urban%20Chinese%20setting%2C%20gentle%20cinematic%20tone%2C%20hopeful%20atmosphere&width=600&height=900&seq=movie-comedy-2&orientation=portrait',
    isHot: false,
    isNew: true,
    region: '中国大陆',
    fullDescription: '在经历了与小文的奇妙缘分之后，莫三妹的殡葬店有了新的面貌。生活似乎步入了正轨，直到一位神秘的老人找上门来，带来了一个不可思议的委托——为一只陪伴主人二十年的宠物猫举办一场体面的葬礼。这个看似荒诞的请求，却让莫三妹重新思考生与死的意义，以及那些我们习以为常却最为珍贵的情感联系。',
    releaseDate: '2025-06-15',
    language: '汉语普通话',
  },
  {
    id: 'movie-10',
    title: '白蛇：浮生',
    category: '动画片',
    categorySlug: 'animation',
    year: 2024,
    rating: 8.3,
    duration: '135分钟',
    director: '黄家康 / 赵霁',
    cast: ['张喆', '杨天翔', '唐小喜'],
    description: '小白为救许仙不惜水漫金山，被法海镇压雷峰塔下。小青为救姐姐，闯入修罗城历经磨难，姐妹情深感动天地。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20animation%20movie%20poster%20with%20white%20snake%20goddess%2C%20flowing%20traditional%20robes%2C%20ethereal%20water%20and%20mist%2C%20ancient%20Chinese%20aesthetic%2C%20dreamy%20atmospheric%20lighting%2C%20elegant%20fantasy%20style&width=600&height=900&seq=movie-animation-2&orientation=portrait',
    isHot: false,
    isNew: false,
    region: '中国大陆',
    fullDescription: '白蛇小白为救回许仙的生命，不惜水漫金山寺，触犯天条。法海将其镇压于雷峰塔下。小青为救出被困的姐姐，毅然闯入神秘的修罗城。在这个充满危险与诱惑的异世界中，小青历经重重考验，逐渐领悟到力量与牺牲的真谛。姐妹俩跨越生死的深情，最终感动了天地。',
    releaseDate: '2024-08-10',
    language: '汉语普通话',
  },
  {
    id: 'movie-11',
    title: '速度与激情11',
    category: '动作片',
    categorySlug: 'action',
    year: 2025,
    rating: 7.6,
    duration: '142分钟',
    director: '路易斯·莱特里尔',
    cast: ['范·迪塞尔', '杰森·斯坦森', '米歇尔·罗德里格兹'],
    description: '多米尼克家族面临前所未有的危机，一个来自过去的敌人卷土重来。全球各地的街头飙车大战再次升级，家族团结是最后的武器。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fast%20and%20furious%20style%20movie%20poster%20with%20luxury%20cars%20racing%20through%20city%2C%20explosive%20action%2C%20neon%20lights%2C%20dynamic%20motion%20blur%2C%20cinematic%20adrenaline%2C%20dark%20urban%20aesthetic&width=600&height=900&seq=movie-action-3&orientation=portrait',
    isHot: true,
    isNew: false,
    region: '美国',
    fullDescription: '多米尼克·托雷托和他的家族本以为终于可以过上平静的生活，然而一个来自过去的强大敌人——与家族有着血海深仇的国际犯罪集团头目——横空出世，打破了一切安宁。从洛杉矶到东京，从迪拜到里约，家族成员再次集结，驾驶着顶级改装赛车，在全球各地的街头上演生死时速。这一次，他们面对的不仅是速度的较量，更是对家族信念的终极考验。',
    releaseDate: '2025-04-04',
    language: '英语',
  },
  {
    id: 'movie-12',
    title: '阿凡达3：火与烬',
    category: '科幻片',
    categorySlug: 'scifi',
    year: 2025,
    rating: 8.5,
    duration: '168分钟',
    director: '詹姆斯·卡梅隆',
    cast: ['萨姆·沃辛顿', '佐伊·索尔达娜', '西格妮·韦弗'],
    description: '杰克和奈提莉在潘多拉星球上面临新的威胁，这一次他们将遇到以火为生的纳美人部落——灰烬族，展开全新的冒险篇章。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Avatar%20movie%20poster%20with%20blue%20alien%20characters%20in%20volcanic%20landscape%2C%20fire%20and%20lava%20elements%2C%20epic%20fantasy%20world%2C%20cinematic%20grandeur%2C%20bioluminescent%20details%2C%20otherworldly%20atmosphere&width=600&height=900&seq=movie-scifi-2&orientation=portrait',
    isHot: true,
    isNew: true,
    region: '美国',
    fullDescription: '在击败人类入侵者数年之后，杰克·萨利和奈提莉在潘多拉星球上建立了新的家园，孩子们也逐渐长大。然而和平并未持续太久——一支全新的人类远征队抵达潘多拉，带来了更先进的武器和更残酷的计划。与此同时，杰克一家发现了潘多拉上一个从未接触过的纳美人部落——以火山为家、以火焰为信仰的"灰烬族"。两个部落之间存在着古老的恩怨，而人类的新威胁将迫使他们在毁灭与共存之间做出选择。',
    releaseDate: '2025-12-19',
    language: '英语',
  },
  {
    id: 'movie-13',
    title: '唐人街探案4',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2025,
    rating: 7.5,
    duration: '138分钟',
    director: '陈思诚',
    cast: ['王宝强', '刘昊然', '妻夫木聪', '托尼·贾'],
    description: '唐仁和秦风来到伦敦，卷入一场涉及世界名画的跨国迷案。各国侦探齐聚英伦，一场智商与笑料的巅峰对决就此展开。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Comedy%20mystery%20movie%20poster%20set%20in%20London%20with%20detective%20characters%2C%20Big%20Ben%20background%2C%20colorful%20quirky%20style%2C%20mysterious%20and%20humorous%20vibe%2C%20cinematic%20comedy%20aesthetic&width=600&height=900&seq=movie-comedy-3&orientation=portrait',
    isHot: false,
    isNew: true,
    region: '中国大陆',
    fullDescription: '世界侦探大赛在伦敦盛大开幕，唐仁和秦风受邀参加。然而比赛尚未开始，大英博物馆内一幅价值连城的名画离奇失踪，所有侦探都成为了嫌疑人。在伦敦的迷雾之中，唐仁和秦风必须与来自日本、泰国、英国等各国的顶尖侦探们一边合作一边竞争，在泰晤士河畔、大本钟下展开一场笑料百出又扣人心弦的探案之旅。',
    releaseDate: '2025-02-08',
    language: '汉语普通话',
  },
  {
    id: 'movie-14',
    title: '独行月球2',
    category: '科幻片',
    categorySlug: 'scifi',
    year: 2025,
    rating: 7.7,
    duration: '132分钟',
    director: '张吃鱼',
    cast: ['沈腾', '马丽', '黄才伦'],
    description: '月球基地重启计划启动，一支新的宇航员队伍登上月球。然而他们发现，月球上似乎还有其他人留下的痕迹……',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sci-fi%20comedy%20movie%20poster%20with%20astronaut%20on%20moon%20surface%2C%20lunar%20base%20in%20background%2C%20humorous%20yet%20epic%20tone%2C%20starry%20sky%2C%20cinematic%20space%20adventure%20style%2C%20warm%20and%20cool%20contrast&width=600&height=900&seq=movie-scifi-3&orientation=portrait',
    isHot: false,
    isNew: true,
    region: '中国大陆',
    fullDescription: '在独孤月牺牲自己拯救地球的数年之后，人类重启了月球探索计划。一支全新的宇航员队伍降落在月球表面，他们的任务是评估重建月球基地的可行性。然而在探索过程中，队员们发现了令人震惊的证据——月球上似乎有某种超出人类认知的存在留下的痕迹。与此同时，地球上的科学家们也探测到了来自月球的神秘信号。这一切究竟是自然的巧合，还是宇宙中另有智慧生命？',
    releaseDate: '2025-08-28',
    language: '汉语普通话',
  },
  {
    id: 'movie-15',
    title: '志愿军：雄兵出击2',
    category: '战争片',
    categorySlug: 'war',
    year: 2025,
    rating: 8.4,
    duration: '155分钟',
    director: '陈凯歌',
    cast: ['唐国强', '王砚辉', '刘劲', '辛柏青'],
    description: '抗美援朝战争进入关键阶段，志愿军将士在松骨峰、上甘岭等战场浴血奋战，用鲜血和生命谱写了保家卫国的壮丽诗篇。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20war%20movie%20poster%20showing%20Chinese%20soldiers%20in%20heroic%20battle%2C%20mountainous%20Korean%20landscape%2C%20dramatic%20smoke%20and%20fire%2C%20patriotic%20tone%2C%20grand%20cinematic%20composition%2C%20golden%20hour%20lighting&width=600&height=900&seq=movie-war-2&orientation=portrait',
    isHot: false,
    isNew: true,
    region: '中国大陆',
    fullDescription: '1950年深秋，中国人民志愿军跨过鸭绿江，奔赴抗美援朝战场。在松骨峰阻击战中，一个连的战士以血肉之躯阻挡了美军一个师的进攻，创造了战争史上的奇迹。在上甘岭战役中，志愿军将士在不足四平方公里的阵地上，承受了敌人日均数万发炮弹的轰炸，坚守阵地43天。这部影片全景式展现了志愿军将士们在极端艰苦的条件下，以钢铁般的意志保卫和平的英雄故事。',
    releaseDate: '2025-10-01',
    language: '汉语普通话',
  },
  {
    id: 'movie-16',
    title: '热烈2',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2025,
    rating: 7.8,
    duration: '118分钟',
    director: '大鹏',
    cast: ['黄渤', '王一博', '刘敏涛', '岳云鹏'],
    description: '惊叹号舞团在全国大赛夺冠后声名鹊起，然而通往世界舞台的道路布满荆棘。舞团成员们用热爱和坚持，再次点燃街舞之魂。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dance%20movie%20poster%20with%20street%20dancers%20in%20dynamic%20poses%2C%20energetic%20lighting%2C%20urban%20street%20background%2C%20vibrant%20colors%2C%20youthful%20spirit%2C%20cinematic%20dance%20energy&width=600&height=900&seq=movie-comedy-4&orientation=portrait',
    isHot: false,
    isNew: false,
    region: '中国大陆',
    fullDescription: '惊叹号舞团在全国街舞大赛中夺冠之后，获得了参加世界街舞大赛的资格。然而通往世界冠军的道路远比想象中艰难——资金短缺、队员伤病、内部矛盾接踵而至。面对重重困难，教练丁雷和队长陈烁带领队员们以对街舞的纯粹热爱为动力，在一次次跌倒和爬起中找到了团队真正的默契与力量。',
    releaseDate: '2025-07-05',
    language: '汉语普通话',
  },
  {
    id: 'movie-17',
    title: '坚如磐石',
    category: '悬疑片',
    categorySlug: 'suspense',
    year: 2023,
    rating: 7.9,
    duration: '128分钟',
    director: '张艺谋',
    cast: ['雷佳音', '张国立', '于和伟', '周冬雨'],
    description: '一名普通的技术科警察意外卷入一场惊天大案，在权力、金钱与正义之间，他选择了坚守底线，揭开层层黑幕。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20police%20officer%20in%20dark%20city%2C%20corruption%20theme%2C%20gritty%20realistic%20style%2C%20moody%20noir%20lighting%2C%20tension-filled%20atmosphere%2C%20Chinese%20urban%20noir&width=600&height=900&seq=movie-suspense-3&orientation=portrait',
    isHot: false,
    isNew: false,
    region: '中国大陆',
    fullDescription: '技术科警察苏见明在一次例行检查中，偶然发现了一枚神秘的手机，其中藏有大量不为人知的秘密。随着调查的深入，他逐渐揭开了一个涉及到政商勾结、利益输送的巨大黑幕。在这场正与邪的较量中，苏见明面对的是来自各方的巨大压力和生命威胁。但他如同磐石一般坚定不移，誓要用法律的武器斩断这条黑暗的利益链条。',
    releaseDate: '2023-09-28',
    language: '汉语普通话',
  },
  {
    id: 'movie-18',
    title: '深海',
    category: '动画片',
    categorySlug: 'animation',
    year: 2023,
    rating: 8.0,
    duration: '112分钟',
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文', '滕奎兴'],
    description: '一个沉溺于悲伤中的女孩参宿，意外坠入神秘的深海世界。在那里，她遇到了一位奇特的厨师南河，开启了一场治愈心灵的奇幻冒险。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20girl%20in%20deep%20ocean%20world%2C%20colorful%20fantasy%20sea%20creatures%2C%20dreamy%20underwater%20lighting%2C%20ink%20wash%20painting%20style%2C%20emotional%20and%20surreal%2C%20vibrant%20particle%20effects&width=600&height=900&seq=movie-animation-3&orientation=portrait',
    isHot: false,
    isNew: false,
    region: '中国大陆',
    fullDescription: '小女孩参宿在父母离异后一直沉浸在悲伤之中。在一次海上旅行中，她意外坠入了深海，来到了一个色彩斑斓、光怪陆离的深海大饭店。这里有一位奇特的厨师南河，以及一群可爱的海洋生物。在这个梦幻般的世界里，参宿经历了一段既奇妙又感人的冒险，逐渐学会了面对失去、拥抱希望。',
    releaseDate: '2023-01-22',
    language: '汉语普通话',
  },
  {
    id: 'movie-19',
    title: '长安三万里',
    category: '动画片',
    categorySlug: 'animation',
    year: 2023,
    rating: 8.2,
    duration: '168分钟',
    director: '谢君伟 / 邹靖',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    description: '安史之乱后，大唐由盛转衰。诗人高适在困顿中回忆与李白数十年的友情，一段关于诗歌、理想与家国情怀的厚重史诗徐徐展开。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animation%20movie%20poster%20featuring%20Tang%20Dynasty%20poets%2C%20ancient%20Changan%20city%20background%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20golden%20sunset%2C%20elegant%20classical%20aesthetic&width=600&height=900&seq=movie-animation-4&orientation=portrait',
    isHot: false,
    isNew: false,
    region: '中国大陆',
    fullDescription: '安史之乱爆发后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。两个性格迥异的年轻人，在盛世大唐相遇相知，一同追逐诗歌与功名的梦想。随着安史之乱的爆发，大唐由盛转衰，两个人的命运也走向了截然不同的方向。这是关于诗歌、友情、理想与家国情怀的壮丽史诗。',
    releaseDate: '2023-07-08',
    language: '汉语普通话',
  },
  {
    id: 'movie-20',
    title: '拯救嫌疑人',
    category: '悬疑片',
    categorySlug: 'suspense',
    year: 2023,
    rating: 7.6,
    duration: '120分钟',
    director: '张末',
    cast: ['张小斐', '李鸿其', '惠英红', '王子异'],
    description: '金牌律师陈智琪的女儿被绑架，绑匪要求她为一个死刑犯做无罪辩护。在真相与亲情之间，她必须在限定时间内做出抉择。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Legal%20thriller%20movie%20poster%20with%20female%20lawyer%2C%20courtroom%20drama%2C%20tense%20atmosphere%2C%20dark%20and%20cold%20color%20palette%2C%20cinematic%20suspense%2C%20professional%20yet%20threatening%20mood&width=600&height=900&seq=movie-suspense-4&orientation=portrait',
    isHot: false,
    isNew: false,
    region: '中国大陆',
    fullDescription: '金牌女律师陈智琪在事业巅峰期遭遇了人生最大的危机——她的女儿被神秘人绑架。绑匪开出了一个匪夷所思的条件：为一名已经被判处死刑的杀人犯做无罪辩护，并且在五天内成功翻案，否则她的女儿将性命不保。陈智琪陷入了道德与亲情的两难境地，她必须在极短的时间内找出案件真相，同时与绑匪展开一场惊心动魄的博弈。',
    releaseDate: '2023-11-01',
    language: '汉语普通话',
  },
  {
    id: 'movie-21',
    title: '三大队',
    category: '悬疑片',
    categorySlug: 'suspense',
    year: 2023,
    rating: 8.0,
    duration: '135分钟',
    director: '戴墨',
    cast: ['张译', '李晨', '魏晨', '曹炳琨'],
    description: '一名刑警在追捕逃犯时因意外被判入狱。出狱后，他化身平民，以普通人的身份继续追踪那个逍遥法外的凶手，十二年从未放弃。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crime%20drama%20movie%20poster%20with%20detective%20chasing%20criminal%2C%20gritty%20realistic%20Chinese%20urban%20setting%2C%20rainy%20streets%2C%20determined%20expression%2C%20dark%20moody%20cinematography%2C%20neo-noir%20style&width=600&height=900&seq=movie-suspense-5&orientation=portrait',
    isHot: false,
    isNew: false,
    region: '中国大陆',
    fullDescription: '刑警程兵在追捕一名连环杀人案凶手时发生意外，导致一名嫌犯死亡，被判入狱。十二年后出狱，他发现那个真正的凶手依然逍遥法外。失去了警察身份的程兵，化身为一名普通百姓，凭借当年在三大队积累的办案经验和直觉，独自踏上了追凶之路。十二年光阴改变了很多，但不变的是他对正义的执着追求。',
    releaseDate: '2023-12-02',
    language: '汉语普通话',
  },
  {
    id: 'movie-22',
    title: '满江红2',
    category: '悬疑片',
    categorySlug: 'suspense',
    year: 2025,
    rating: 7.8,
    duration: '148分钟',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    description: '南宋年间，又一封事关国家命运的密信失踪。一群小人物再次卷入惊天阴谋，在重重迷局中用智慧与勇气守护家国秘密。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%20with%20ancient%20courtyard%2C%20soldiers%20in%20Song%20Dynasty%20armor%2C%20dark%20red%20tones%2C%20mysterious%20atmosphere%2C%20cinematic%20period%20drama%2C%20intricate%20shadows&width=600&height=900&seq=movie-suspense-6&orientation=portrait',
    isHot: false,
    isNew: true,
    region: '中国大陆',
    fullDescription: '南宋绍兴年间，宰相府中再次发生离奇事件。一封记录了边境军情的绝密密信在重重守卫之下不翼而飞，一旦落入金人之手，大宋江山将危在旦夕。一个小兵、一个亲兵营副统领、一个舞姬和一个更夫，这四个看似毫不相干的小人物，在命运的推动下组成了一个奇特的联盟。他们在有限的时间内，必须在宰相府的重重迷局中找到密信，揪出内鬼。',
    releaseDate: '2025-01-25',
    language: '汉语普通话',
  },
  {
    id: 'movie-23',
    title: '爱情神话2',
    category: '爱情片',
    categorySlug: 'romance',
    year: 2025,
    rating: 8.1,
    duration: '115分钟',
    director: '邵艺辉',
    cast: ['徐峥', '马伊琍', '吴越', '倪虹洁'],
    description: '老白的画廊迎来了国际巡展的机会，而他与李小姐的关系也到了关键节点。在上海的弄堂与摩天楼之间，中年人的爱情再次悄然绽放。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20comedy-drama%20movie%20poster%20set%20in%20Shanghai%2C%20middle-aged%20couple%20walking%20in%20tree-lined%20street%2C%20warm%20autumn%20tones%2C%20gentle%20cinematic%20lighting%2C%20urban%20romance%20aesthetic%2C%20nostalgic%20mood&width=600&height=900&seq=movie-romance-1&orientation=portrait',
    isHot: false,
    isNew: true,
    region: '中国大陆',
    fullDescription: '画家老白的事业迎来了新的转机——他的作品受邀参加巴黎的一个国际画展。然而事业上的成功却让他和李小姐之间的关系陷入了微妙的僵局。在上海这座既摩登又市井的城市里，一群中年人用自己的方式诠释着爱情、友情和生活的意义。在法租界的梧桐树下、在老弄堂的烟火气中，他们的故事如同一杯陈年黄酒，醇厚而绵长。',
    releaseDate: '2025-09-09',
    language: '汉语普通话',
  },
  {
    id: 'movie-24',
    title: '侏罗纪世界4',
    category: '科幻片',
    categorySlug: 'scifi',
    year: 2025,
    rating: 7.3,
    duration: '140分钟',
    director: '加雷思·爱德华兹',
    cast: ['斯嘉丽·约翰逊', '乔纳森·贝利', '马赫沙拉·阿里'],
    description: '恐龙与人类共存的第五年，全球生态平衡被彻底打破。一支精英团队踏上了寻找恢复生态平衡密钥的危险旅程。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Jurassic%20World%20style%20movie%20poster%20with%20giant%20dinosaurs%20in%20modern%20city%2C%20epic%20scale%2C%20dramatic%20tension%2C%20cinematic%20adventure%2C%20sunset%20lighting%2C%20survival%20theme&width=600&height=900&seq=movie-scifi-4&orientation=portrait',
    isHot: true,
    isNew: true,
    region: '美国',
    fullDescription: '在恐龙被释放到全球各地的五年后，地球的生态系统已经发生了不可逆转的变化。人类与史前巨兽的共存充满了危险与不确定性。一支由顶尖科学家、探险家和军事人员组成的精英团队，被派往一个偏远的恐龙保护区，寻找可能恢复生态平衡的关键技术。然而他们很快发现，最大的威胁并非来自巨型恐龙，而是那些企图利用混乱局面谋取私利的人类。',
    releaseDate: '2025-07-02',
    language: '英语',
  },
];

export const hotMovies = movies.filter((m) => m.isHot);
export const newMovies = movies.filter((m) => m.isNew);
export const getMoviesByCategory = (slug: string) =>
  movies.filter((m) => m.categorySlug === slug);
export const getMovieById = (id: string) =>
  movies.find((m) => m.id === id);

export const faqItems = [
  {
    question: '星空电影网的电影资源是免费的吗？',
    answer: '是的，星空电影网所有电影资源均为高清免费在线观看。我们致力于为广大影迷提供最便捷、最优质的观影体验，无需注册，无需付费，打开即可畅享精彩电影。',
  },
  {
    question: '如何快速找到我想看的电影？',
    answer: '您可以通过首页的分类导航栏按类型筛选电影，包括动作片、喜剧片、科幻片、爱情片、恐怖片、动画片、悬疑片、战争片等丰富分类。也可以在热门推荐和最新电影板块中浏览精选片单。',
  },
  {
    question: '星空电影网支持哪些设备观看？',
    answer: '星空电影网采用先进的响应式网页设计，完美适配电脑、平板和手机等各类设备。无论您使用什么设备，都能获得流畅、清晰的高清观影体验。',
  },
  {
    question: '电影更新频率是怎样的？',
    answer: '我们的编辑团队每天都会更新片单，第一时间收录最新上映的热门电影和经典佳作。您可以在"最新电影"板块中查看最近更新的影片。',
  },
  {
    question: '观看电影需要安装播放器或插件吗？',
    answer: '不需要。星空电影网采用先进的网页播放技术，您只需要使用浏览器即可直接在线观看，无需安装任何播放器或插件，方便快捷。',
  },
  {
    question: '如何联系星空电影网？',
    answer: '您可以通过"关于我们"页面查看我们的联系方式，包括电子邮箱、客服电话等。我们非常重视每一位用户的反馈和建议，期待您的来信。',
  },
];